import PropTypes from 'prop-types';
import CheckBoxField from "../../../../Form/CheckBoxField/CheckBoxField";
import { get, indexOf } from 'lodash';
import cn from "../../../../../utils/cn";
import highlightTerm from "./highlightTerm";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FilterOption = _ref => {
  let {
    option,
    onChange,
    activeFilters = [],
    searchTerm = '',
    uniqIdPrefix = '',
    disableParentSelect = false
  } = _ref;
  const label = searchTerm ? highlightTerm(option.label, searchTerm) : option.label;
  const id = "".concat(uniqIdPrefix).concat(option.value);
  const filterOptionClass = () => cn({
    'h-full font-regular-font': true
  });
  const parentOptionClass = () => cn({
    'px-3 h-10 place-content-center': true,
    'border-l-4 border-transparent': true,
    'hover:border-action-blue hover:bg-medium-fill-blue': true
  });
  const childOptionClass = () => cn("".concat(id, "__child"), {
    'px-6 h-10 place-content-center border-l-4 border-transparent': true,
    'hover:border-action-blue hover:bg-medium-fill-blue': true
  });
  const onMouseEnter = () => {
    const children = Array.from(document.getElementsByClassName("".concat(id, "__child")));
    children.map(child => {
      child.style.background = '#ECF5FD';
      child.style.borderLeft = '4px solid #4467AB';
    });
  };
  const onMouseLeave = () => {
    const children = Array.from(document.getElementsByClassName("".concat(id, "__child")));
    children.map(child => {
      child.style.background = '';
      child.style.borderLeft = '';
    });
  };
  if (get(option, 'hasChildren', false)) {
    return /*#__PURE__*/_jsxs("div", {
      className: filterOptionClass(),
      children: [/*#__PURE__*/_jsx("div", {
        className: parentOptionClass(),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: disableParentSelect ? /*#__PURE__*/_jsx("span", {
          className: "text-sm font-heavy-font",
          children: label
        }) : /*#__PURE__*/_jsx(CheckBoxField, {
          "data-testid": disableParentSelect ? null : "filter-option",
          id: id,
          label: label,
          value: indexOf(activeFilters, option.value) >= 0,
          onChange: e => onChange(option, e.target.value),
          style: {
            label: 'uppercase font-heavy-font'
          }
        })
      }), get(option, 'children', []).map(child => /*#__PURE__*/_jsx("div", {
        "data-testid": "filter-option",
        className: childOptionClass(),
        "aria-label": child.label,
        tabIndex: 0,
        children: /*#__PURE__*/_jsx(CheckBoxField, {
          id: "".concat(id, "__").concat(child.value),
          label: searchTerm ? highlightTerm(child.label, searchTerm) : child.label,
          value: indexOf(activeFilters, child.value) >= 0,
          onChange: e => onChange(child, e.target.value)
        })
      }, "".concat(id, "__").concat(child.value)))]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "filter-option",
    className: filterOptionClass(),
    "aria-label": label,
    tabIndex: 0,
    children: /*#__PURE__*/_jsx("div", {
      className: parentOptionClass(),
      children: /*#__PURE__*/_jsx(CheckBoxField, {
        id: id,
        label: label,
        value: indexOf(activeFilters, option.value) >= 0,
        onChange: e => onChange(option, e.target.value),
        style: {
          label: 'capitalize'
        }
      })
    })
  });
};
FilterOption.propTypes = {
  activeFilters: PropTypes.array,
  option: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  uniqIdPrefix: PropTypes.string,
  disableParentSelect: PropTypes.bool
};
export default FilterOption;
//# sourceMappingURL=FilterOption.js.map